import api from '../config/axiosConfig';
import { 
  ReturnRequest, 
  ReturnResponse,
  ReturnCheckRequest,
  ReturnCheckResponse,
  ReturnCreate
} from '../types/return';
import { API_BASE_URL } from '../utils/constants';

export enum ReturnStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum ReturnCondition {
  DEFECTIVE = 'DEFECTIVE',
  WRONG_ITEM = 'WRONG_ITEM',
  NOT_AS_DESCRIBED = 'NOT_AS_DESCRIBED',
  CHANGED_MIND = 'CHANGED_MIND',
  OTHER = 'OTHER',
}

export enum ReturnType {
  REFUND = 'REFUND',
  EXCHANGE = 'EXCHANGE',
}

export interface ReturnItem {
  id: number;
  item_id: number;
  item_sku: string;
  item_name: string;
  qty: number;
  price: number;
  refund_amount: number;
}

export interface ReturnApprove {
  notes?: string;
}

export interface ReturnReject {
  reason: string;
}

const API_URL = `${API_BASE_URL}/returns`;

// ✅ Check return eligibility (STEP 1)
export const checkReturnEligibility = async (
  request: ReturnCheckRequest
): Promise<ReturnCheckResponse> => {
  const response = await api.post<ReturnCheckResponse>(
    `${API_URL}/check`,
    request
  );
  return response.data;
};

// ✅ Create return request (STEP 2) - CORRECT VERSION
export const createReturnCorrect = async (
  request: ReturnCreate
): Promise<ReturnResponse> => {
  const response = await api.post<ReturnResponse>(API_URL, request);
  return response.data;
};

// Function to fetch all return requests
export const fetchReturns = async (params?: {
  branch_id?: number;
  status?: ReturnStatus | 'draft';
  return_type?: ReturnType;
  start_date?: string;
  end_date?: string;
  page?: number;
  page_size?: number;
}): Promise<ReturnResponse[]> => {
  const response = await api.get<ReturnResponse[]>(API_URL, { params });
  return response.data;
};

export const getReturnById = async (id: number): Promise<ReturnResponse> => {
  const response = await api.get<ReturnResponse>(`${API_URL}/${id}`);
  return response.data;
};

// Legacy function - kept for backward compatibility
// ⚠️ DEPRECATED: Use checkReturnEligibility + createReturnCorrect instead
export const createReturn = async (returnRequest: ReturnRequest): Promise<ReturnResponse> => {
  const response = await api.post<ReturnResponse>(API_URL, returnRequest);
  return response.data;
};

// Function to approve a return request (backend uses POST not PATCH)
export const approveReturn = async (
  id: number | string,
  data?: ReturnApprove
): Promise<ReturnResponse> => {
  const returnId = typeof id === 'string' ? parseInt(id) : id;
  const response = await api.post<ReturnResponse>(
    `${API_URL}/${returnId}/approve`,
    data
  );
  return response.data;
};

// Function to reject a return request (backend uses POST not PATCH)
export const rejectReturn = async (
  id: number | string,
  data: ReturnReject
): Promise<ReturnResponse> => {
  const returnId = typeof id === 'string' ? parseInt(id) : id;
  const response = await api.post<ReturnResponse>(
    `${API_URL}/${returnId}/reject`,
    data
  );
  return response.data;
};
